import React, { Component } from 'react'
import { Line } from 'react-chartjs-2'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import moment from 'moment'
import {
  setListHistoryData,
  resetChartData,
} from 'reducers/environmentMonitor/reducer'
import { getChartsRatio } from 'helpers/slaMonitor'
import { DEFAULT_CHART_COLOR_RGBA } from 'constants/insight'
import { getMaxRangeLimit, getMinRangeLimit } from 'helpers/environmentMonitor'
import { BIG_STONE, GLACIER, GREY } from 'constants/colors'
import messages from '../translate'

class ChartHistorical extends Component {
  constructor(props) {
    super(props)
    this.state = {
      datasetIndex: this.props.datasetIndex,
      itemIndex: 0,
    }
  }

  componentWillUnmount() {
    this.props.resetChartData()
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.chartData !== nextProps.chartData) {
      const data = nextProps.chartData.get('data').toJS()
      this.onChangeListViewData(data, this.state.itemIndex)
    }

    return true
  }

  onChartClick = evt => {
    if (evt.length > 0 && evt[0]._datasetIndex !== undefined) {
      const datasetIndex = evt[0]._datasetIndex
      const itemIndex = evt[0]._index
      const data = this.props.chartData.get('data').toJS()
      this.onChangeListViewData(data, itemIndex)
      this.setState({ datasetIndex, itemIndex })
    }
  }

  onChangeListViewData = (data, itemIndex) => {
    if (data !== undefined && data.length > 0) {
      const result = { time: moment, data: [] }
      for (const index in data) {
        if (data.hasOwnProperty(index)) {
          const datum = data[index]

          if (datum.data !== undefined && datum.data.length > 0) {
            result.time = moment(datum.data[itemIndex].x)
            result.data.push({
              label: datum.label,
              value: Math.round(datum.data[itemIndex].y * 100) / 100,
            })
          }
        }
      }

      this.props.setListHistoryData(result)
    }
  }

  repeatDataset = () => {
    const { itemIndex } = this.state
    const { lineLevels } = this.props
    const colors = [GLACIER, DEFAULT_CHART_COLOR_RGBA, BIG_STONE]
    const chartData = this.props.chartData.toJS()
    let datasets = []

    if (chartData !== undefined && chartData.data !== undefined) {
      datasets = chartData.data.map((dataItem, index) => ({
        label: dataItem.label,
        backgroundColor: 'transparent',
        borderColor: colors[index] ? colors[index] : DEFAULT_CHART_COLOR_RGBA,
        fill: '-1',
        pointRadius: dataItem.data.map((e, i) => (i === itemIndex ? 5 : 0)),
        pointBackgroundColor: colors[index]
          ? colors[index]
          : DEFAULT_CHART_COLOR_RGBA,
        pointHoverRadius: 10,
        pointHitRadius: 30,
        data: dataItem.data,
      }))
    }

    if (lineLevels && lineLevels.line) {
      datasets.push({
        type: 'line',
        label: 'line',
        fill: false,
        tooltip: false,
        pointRadius: 0,
        pointHitRadius: 0,
        pointBorderWidth: 0,
        pointHoverRadius: 0,
        borderDash: [2, 7],
        borderColor: GREY,
        offset: false,
        data: datasets[datasets.length - 1].data.map(item => ({
          x: item.x,
          y: lineLevels.level,
        })),
      })
    }

    return datasets
  }

  chartData = () => ({
    datasets: this.repeatDataset(),
  })

  chartOptions = () => {
    const {
      intl: { formatMessage },
      unit,
      chartData,
    } = this.props

    return {
      aspectRatio: getChartsRatio(),
      responsive: true,
      legend: {
        display: true,
        labels: {
          boxWidth: 30,
          filter(legendItem) {
            if (legendItem.text !== 'line') {
              return legendItem
            }
          },
        },
      },
      elements: {
        line: {
          tension: 0,
        },
      },
      tooltips: {
        mode: 'x',
        intersect: false,
        position: 'nearest',
        itemSort(a, b) {
          return b.value - a.value
        },
        callbacks: {
          title: e =>
            `${formatMessage(messages.today).toUpperCase()} - ${moment(
              e[0].label,
            ).format('HH:mm')}`,
          label: (tooltipItem, data) => {
            const dataset = data.datasets[tooltipItem.datasetIndex]
            const item = dataset.data[tooltipItem.index]
            const value = Math.round(item.y * 100) / 100

            if (dataset.label === 'line') {
              return null
            }

            return `${dataset.label}: ${value}`
          },
        },
      },
      scales: {
        xAxes: [
          {
            type: 'time',
            distribution: 'series',
            time: {
              unit: 'hour',
              displayFormats: {
                hour: 'HH:mm',
              },
            },
            scaleLabel: {
              display: true,
              labelString: formatMessage(messages.hour),
            },
            gridLines: {
              drawOnChartArea: false,
            },
          },
        ],
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: unit,
            },
            ticks: {
              beginAtZero: true,
              max: getMaxRangeLimit(chartData),
              min: getMinRangeLimit(chartData),
            },
          },
        ],
      },
      plugins: {
        datalabels: {
          display: false,
        },
      },
    }
  }

  render() {
    return (
      <Line
        width={null}
        height={null}
        data={this.chartData()}
        options={this.chartOptions()}
        getElementAtEvent={this.onChartClick}
      />
    )
  }
}

export default connect(null, {
  setListHistoryData,
  resetChartData,
})(injectIntl(ChartHistorical))
